module.exports = __webpack_public_path__ + "static/img/akum_800_100.55afbb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_100.svg
// module id = tBW5
// module chunks = 1